import React from 'react';

export function Card({ children, className = '', hover = false, onClick }) {
  return (
    <div
      className={`
        bg-[#0f0f11] border border-white/[0.04] rounded-xl
        ${hover ? 'transition-all duration-200 hover:border-white/[0.08] hover:bg-[#141416] cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export function GradientCard({ children, className = '', glow = false, onClick }) {
  return (
    <div className={`relative group ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
      <div className="absolute inset-0 rounded-2xl p-[1px] bg-gradient-to-b from-white/[0.1] to-white/[0.02]">
        <div className="h-full w-full rounded-2xl bg-[#0f0f11]" />
      </div>
      {glow && (
        <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-b from-red-500/[0.05] to-transparent pointer-events-none" />
      )}
      <div className={`relative ${className}`}>{children}</div>
    </div>
  );
}

export function CardHeader({ children, className = '' }) {
  return <div className={`px-6 py-5 border-b border-white/[0.04] ${className}`}>{children}</div>;
}

export function CardBody({ children, className = '' }) {
  return <div className={`p-6 ${className}`}>{children}</div>;
}

export function CardFooter({ children, className = '' }) {
  return <div className={`px-6 py-4 border-t border-white/[0.04] bg-[#141416]/50 ${className}`}>{children}</div>;
}

// Backwards compatibility aliases
export function CardContent({ children, className = '' }) {
  return <div className={`p-6 ${className}`}>{children}</div>;
}

export function CardTitle({ children, className = '' }) {
  return <div className={`font-semibold leading-none tracking-tight text-white ${className}`}>{children}</div>;
}

export function CardDescription({ children, className = '' }) {
  return <div className={`text-sm text-zinc-400 ${className}`}>{children}</div>;
}

export default Card;
